import template from './index.pug'

const ERRORS = [404]

// @vue/component
export default Vue.extend({
  name: 'error-page',
  template: template(),
  computed: {
    errorCode() {
      if (this.$route.params.errorCode) {
        return Number(this.$route.params.errorCode)
      }
      return undefined
    },

    validError() {
      return _.includes(ERRORS, this.errorCode)
    },

    errorTitle() {
      if (this.validError) {
        return this.$t(`errorPage.${this.errorCode}.title`)
      }
      return this.$t('errorPage.default.title')
    },

    errorInfo() {
      if (this.validError) {
        return this.$t(`errorPage.${this.errorCode}.label`)
      }
      return this.$t('errorPage.default.label')
    },

    errorImg() {
      if (this.validError) {
        return require(`assets/images/ilustrations/errors/${this.errorCode}.svg`)
      }
      return require('assets/images/ilustrations/errors/generic-error.svg')
    }
  }
})
